export const USER_PROFILE = "USER_PROFILE"
export const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS"